import { LinearProgress } from "@mui/material";
import { useNavigate } from "react-router";
import { useSupabase } from "../../../../server/supabase/hooks";
import { SupabaseMomentService } from "../../server/supabase-moment-service";

import type { SerialisedEditorDesign } from "../../../message/editor/types/serialised-editor-design";
import type { MomentFormMoment } from "../../types/moment-form-moment";
import type { FC } from "react";

export const CopyMoment: FC<{
  moment: MomentFormMoment;
  noMessage: boolean;
  onError: () => void;
  newTitle: string | null;
}> = ({ moment, noMessage, onError, newTitle }) => {
  const navigate = useNavigate();

  useSupabase(
    async ({ supabase }) => {
      const momentService = new SupabaseMomentService(supabase);

      const { data, error } = await momentService.copyMoment(moment.id, newTitle);
      if (error) {
        console.log("Failed to copy Communication", { error });
        return onError();
      }

      if (noMessage) {
        await momentService.update(data, {
          use_lexical_editor: true,
          email_moment_id: null,
          chat_moment_id: null, // deprecated: old-style chat moments have been archived
          body: null,
          // oxlint-disable-next-line typescript/no-unsafe-type-assertion
          design: {} as SerialisedEditorDesign,
        });
      }
      void navigate(`/moments/${data}`, { replace: true });
    },
    [navigate, noMessage, moment.id, onError, newTitle],
  );

  return <LinearProgress />;
};
